<div class="mat-grid-tile-content">
  <ng-content></ng-content>
</div>
